<template>
<div :style="style">
<el-table
  v-loading="loading"
  :data="listData"
  :height="height"
  stripe
  border
  style="width: 100%">
  <el-table-column
  type="index"
  width="50" label="#" />
  <!-- <el-table-column v-for="item in columns"
  :key="item.prop"
  :prop="item.prop"
  :label="item.label"
  :width="item.width"
  >
  </el-table-column> -->
  <slot></slot>
  <el-table-column
    fixed="right"
    label="操作"
    :width="optWidth">
    <template slot-scope="scope">
      <el-button
        @click="onView(scope.row)"
        type="text"
        size="small">
        查看
      </el-button>

      <el-button
        @click="onProc(scope.row)"
        type="text"
        size="small" v-if="isProc">
        环节情况
      </el-button>
    </template>
  </el-table-column>
</el-table>
<nav style="textAlign: right;" v-if="page">
  <el-pagination
    background
    @size-change="onSize"
    @current-change="onCurrent"
    :current-page="page.currentPage"
    :page-sizes="page.pageSizes"
    :page-size="page.pageSize"
    layout="total, sizes, prev, pager, next, jumper"
    :total="page.total">
  </el-pagination>
</nav>
</div>
</template>

<script>
export default {
  props: {
    loading: Boolean,
    listData: Array,
    onView: Function,
    onProc: Function,
    isProc: Boolean,
    onSize: Function,
    onCurrent: Function,
    page: Object,
    height: Number,
    optWidth: Number,
    style: Object
  },
  methods: {

  }
}
</script>
